import { TierHostItineraries } from 'modules/host-onboarding/model/PotentialItineraries';
import req from 'utils/req';
import { HOST_STATUS } from '~/constants';

type LanguageType = {
  language_code: string;
};

export interface CandidateBody {
  yearsInCity?: number;
  declaredHoursAWeek?: string;
  languages: LanguageType[];
  location: {
    country: string;
    area: string;
  };
}

export type CandidateProcess = {
  completed: boolean;
  progressData: {
    verifications: [
      {
        type: 'PhoneNumber';
        value: string;
      },
      {
        type: 'EmailAddress';
        value: string;
      },
    ];
    onboardingCourseStatus: 'NotStarted' | 'InProgress' | 'Completed';
    tierCoursesStatus: {
      [tier: string]: 'Pristine' | 'InProgress' | 'Completed';
    };
  };
};

export const HostCandidateQueryKeys = ['host', 'candidate'];
export async function getCandidateInfo(accountId: string): Promise<any> {
  if (!accountId) {
    return null;
  }
  const response = await req(
    `${URL_API_HOST}/api/v1/portfolio/host/candidate/${accountId}`,
  )
    .get()
    .catch((e) => ({ status: { type: HOST_STATUS.INITIAL } }));

  return response;
}

export async function setAsCandidate(
  accountId: string,
  body: CandidateBody,
): Promise<any> {
  const response = await req(
    `${URL_API_HOST}/api/v1/portfolio/host/candidate/${accountId}`,
  )
    .post(body)
    .catch((e) => null);

  return response;
}

export async function getCandidateProcess(
  accountId: string,
): Promise<CandidateProcess> {
  if (!accountId) {
    return undefined;
  }
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/candidate/${accountId}/progress`,
  )
    .get()
    .catch(() => null);
}

export async function setCourseCompleted(accountId: string, courseId: string) {
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/candidate/${accountId}/tier-course`,
  ).put({ courseId });
}

export async function activateCandidateToHost(
  accountId: string,
): Promise<CandidateProcess> {
  if (!accountId) {
    return null;
  }
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/candidate/${accountId}/self-activation`,
  ).post();
}

export async function getPotentialItineraries(
  accountId: string,
): Promise<TierHostItineraries[]> {
  if (!accountId) {
    return null;
  }
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/${accountId}/potential-itineraries`,
  )
    .get()
    .catch(() => null);
}
